import React, { useEffect, useState } from "react";
import "./settings-client.scss";
import avatar from "../../../../components/img/no_avatar.png";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { userUpdate } from "../../../../store/actions/auth";
import InputMask from "react-input-mask";
import ChangePhoto from "../../modal/changePhoto";
import ChangesSaved from "../../modal/changes-saved";
import { isPhoneValid } from "../../../../helpers";
import { useSnackbar } from "notistack";

const SettingsClient = () => {
  const user = useSelector((state) => state.auth.user);
  const [changesSaved, setChangesSaved] = useState(false);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const collection = "Client.photo";
  /*  const [birthday, setBirthday] = useState(user.birthday || "");
  const [address, setAddress] = useState(user.address || "");*/
  const [middle_name, setMiddle_name] = useState(user.middle_name || "");
  const { register, errors, handleSubmit } = useForm({});
  const { enqueueSnackbar: noticeF } = useSnackbar();
  const onSubmit = async (data) => {
    const phoneValid = isPhoneValid(data.phone);
    if (!phoneValid) {
      noticeF("Телефон должен быть заполнен полностью", {
        variant: "error",
      });
      return;
    }
    dispatch(
      userUpdate({
        ...data,
        middle_name: middle_name,
      })
    ).then(() => openChangesSaved());
  };
  useEffect(() => {
    document.title = "Настройки";
  }, []);

  const openChangesSaved = () => {
    setChangesSaved(!changesSaved);
    setTimeout(() => {
      setChangesSaved(false);
    }, 1000);
  };

  return (
    <div className="settingClientWrapper">
      <h2>Настройки</h2>
      <div className="settingsClientContainer">
        <div className="settingsClientHeader">
          <img
            alt="avatar"
            src={user.avatar?.full_url || avatar}
            onClick={() => setOpen(!open)}
          />
          <div className="settingsClientHeaderInfo">
            <h3 style={{ fontWeight: 700 }}>{user.last_name}</h3>
            <h3>{user.first_name}</h3>
            <h3>{user.middle_name || ""}</h3>
            <span>{user.birthday}</span>
          </div>
        </div>
        <form
          onSubmit={(e) => e.preventDefault()}
          className="settingsClientContent"
        >
          <h3>Личные данные:</h3>
          <div className="settingClientContentItem">
            <label>Фамилия</label>
            <input
              className="inputSettingsClient"
              name="last_name"
              type="text"
              defaultValue={user.last_name}
              ref={register({
                required: "Вы должны указать фамилию",
              })}
            />
            {errors.last_name && <span>{errors.last_name.message}</span>}
          </div>
          <div className="settingClientContentItem">
            <label>Имя</label>
            <input
              className="inputSettingsClient"
              name="first_name"
              type="text"
              defaultValue={user.first_name}
              ref={register({
                required: "Вы должны указать имя",
              })}
            />
            {errors.first_name && <span>{errors.first_name.message}</span>}
          </div>
          <div className="settingClientContentItem">
            <label>Отчество</label>
            <input
              className="inputSettingsClient"
              name="middle_name"
              type="text"
              value={middle_name}
              onChange={(e) => setMiddle_name(e.target.value)}
            />
          </div>
          <div className="settingClientContentItem">
            <label>Телефон</label>
            <InputMask mask="+7 (999) 999-9999" defaultValue={user.phone}>
              {() => (
                <input
                  className="inputSettingsClient"
                  name="phone"
                  type="text"
                  ref={register({
                    required: "Вы должны указать номер телефона",
                  })}
                />
              )}
            </InputMask>
            {errors.phone && <span>{errors.phone.message}</span>}
          </div>
          <div className="settingClientContentItem">
            <label>Email</label>
            <input
              className="inputSettingsClient"
              name="email"
              type="email"
              defaultValue={user.email}
              ref={register({
                required: "Вы должны указать email",
              })}
            />
            {errors.email && <span>{errors.email.message}</span>}
          </div>
          {/*          <div className="settingClientContentItem">
            <label>День рождения</label>
            <input
              className="inputSettingsClient"
              name="birthday"
              type="date"
              value={birthday}
              onChange={e => setBirthday(e.target.value)}
            />
          </div>
          <div className="settingClientContentItem">
            <label>Адрес проживания</label>
            <input
              className="inputSettingsClient"
              name="address"
              type="text"
              value={address}
              onChange={e => setAddress(e.target.value)}
            />
          </div>*/}
          <Link to="/client/settings/password">Изменить пароль</Link>
          <input
            type="submit"
            onClick={handleSubmit(onSubmit)}
            value="Сохранить"
          />
        </form>
      </div>
      {open && (
        <ChangePhoto
          open={open}
          setOpen={setOpen}
          item={user}
          collection={collection}
        />
      )}
      {changesSaved && <ChangesSaved save={changesSaved} />}
    </div>
  );
};

export default SettingsClient;
